import { render, staticRenderFns } from "./valueColumn.vue?vue&type=template&id=643a1da4&"
import script from "./valueColumn.vue?vue&type=script&lang=js&"
export * from "./valueColumn.vue?vue&type=script&lang=js&"
import style0 from "./valueColumn.vue?vue&type=style&index=0&id=643a1da4&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports